import { createContext, type ReactNode, useContext, useMemo } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';

interface FavoritesContextValue {
  ids: number[];
  count: number;
  has: (id: number) => boolean;
  toggle: (id: number) => void;
}

const FavoritesContext = createContext<FavoritesContextValue | null>(null);

export function FavoritesProvider({ children }: { children: ReactNode }) {
  const [ids, setIds] = useLocalStorage<number[]>('c214_favs', []);

  const value = useMemo<FavoritesContextValue>(
    () => ({
      ids,
      count: ids.length,
      has: (id) => ids.includes(id),
      toggle: (id) =>
        setIds((current) =>
          current.includes(id) ? current.filter((entry) => entry !== id) : [...current, id],
        ),
    }),
    [ids, setIds],
  );

  return <FavoritesContext.Provider value={value}>{children}</FavoritesContext.Provider>;
}

export function useFavorites(): FavoritesContextValue {
  const context = useContext(FavoritesContext);
  if (!context) throw new Error('useFavorites має використовуватись усередині FavoritesProvider');
  return context;
}
